import PasosTurnoTareas from "../PasosTurnoTareas/PasosTurnoTareas";
import { CirculoTarea, LineaContainer } from "./localStyle";

const LineaPasos = ({
  transicionTerminada,
  pasos,
  distance,
  distance2,
  distance3,
}) => {
  return (
    <LineaContainer>
      <CirculoTarea />
      {pasos.map((paso, index) => {
        return (
          <PasosTurnoTareas
            key={index}
            tarea={index}
            pasos={pasos}
            distance={distance}
            distance2={distance2}
            distance3={distance3}
            transicionTerminada={transicionTerminada}
          />
        );
      })}
    </LineaContainer>
  );
};

export default LineaPasos;
